function initStaffAccordion() {	
  jQuery(document).ready( function() {
          if(jQuery('div').hasClass('our-staff-wrapper')) {
            jQuery('.ui-accordion').accordion({
              collapsible:true,
              beforeActivate: function(event, ui) {
                // The accordion believes a panel is being opened
                if (ui.newHeader[0]) {
                    var currHeader  = ui.newHeader;
                    var currContent = currHeader.next('.ui-accordion-content');
                // The accordion believes a panel is being closed
                } else {
                    var currHeader  = ui.oldHeader;
                    var currContent = currHeader.next('.ui-accordion-content');
                }
                // Since we've changed the default behavior, this detects the actual status
                var isPanelSelected = currHeader.attr('aria-selected') == 'true';
                var isPanelExpanded = currHeader.attr('aria-expanded') == 'true';

                // Toggle the panel's header
                currHeader.toggleClass('ui-corner-all',isPanelSelected).toggleClass('ui-accordion-header-active ui-state-active ui-corner-top',!isPanelSelected).attr({'aria-selected':((!isPanelSelected).toString()),'aria-expanded':((!isPanelExpanded).toString())});
                              
                // Toggle the panel's content
                currContent.toggleClass('ui-accordion-content-active',!isPanelSelected)    
                if (isPanelSelected) { currContent.slideUp(); }  else { currContent.slideDown(); }
                return false;
              }
            });
          }   

  });
	
}

export {initStaffAccordion};
